// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import auditEntity from './entities/audit.json';
import auditMenu from '../pages/audit/menu.json';
import auditFullForm from '../pages/audit/forms/full.json';
import auditContextForm from '../pages/audit/forms/context.json';
import auditMiniForm from '../pages/audit/forms/mini.json';
import auditLookupForm from '../pages/audit/forms/lookup.json';
import auditTableView from '../pages/audit/views/table.json';
import auditStagesView from '../pages/audit/views/stages.json';
import auditBacklogView from '../pages/audit/views/backlog.json';
import auditSplitView from '../pages/audit/views/split.json';
import auditCardsView from '../pages/audit/views/cards.json';
import auditCalendarView from '../pages/audit/views/calendar.json';
import auditDashboardView from '../pages/audit/views/dashboard.json';

/** Тип запису «Аудит» зі сторінками пакета: меню, форми та подання з pages/audit/. */
export const auditDefinition: IRecordTypeDefinition = {
  ...auditEntity,
  views: assembleViewSet({
      table: auditTableView,
      stages: auditStagesView,
      backlog: auditBacklogView,
      split: auditSplitView,
      cards: auditCardsView,
      calendar: auditCalendarView,
      dashboard: auditDashboardView,
  }),
  form: auditFullForm,
  forms: { full: auditFullForm, context: auditContextForm, mini: auditMiniForm, lookup: auditLookupForm },
  menu: auditMenu,
} as IRecordTypeDefinition;
